import { log, logMethodCall } from '../utils/debug';
import {
  WIDGET,
} from '../const/common';
import {
  isInViewport,
} from '../utils/dom';
import { markElementAsShown } from '../utils/scriptFunctions';
import Event from '../const/event';
import '../cleverpush-widget';

export function initWidgets(context) {
  logMethodCall('initWidgets');

  const storageKey = 'cleverpush-widgets-shown';
  const shownWidgetsStorage = localStorage.getItem(storageKey);

  let shownWidgets;
  if (shownWidgetsStorage) {
    try {
      shownWidgets = JSON.parse(shownWidgetsStorage);
    } catch (error) {
      log.info('error parsing JSON', error);
    }
  }
  if (!shownWidgets) {
    shownWidgets = [];
  }
  const shownWidgetsSessionStorage = sessionStorage.getItem(storageKey);
  if (shownWidgetsSessionStorage) {
    try {
      shownWidgets = shownWidgets.concat(JSON.parse(shownWidgetsSessionStorage));
    } catch (error) {
      log.info('error parsing JSON', error);
    }
  }

  context.widgets = (context.widgets || []).filter((widget) => !shownWidgets.includes(widget._id));
  (context.config.widgets || []).filter((widget) => widget.autoAppendType === 'selector').forEach((widget) => {
    try {
      if (widget.autoAppendPath) {
        if (!new RegExp(widget.autoAppendPath).test(window.location.pathname)) {
          return;
        }
      }
      if (widget.autoAppendSelector) {
        const target = document.querySelector(widget.autoAppendSelector);
        if (target) {
          const widgetDiv = document.createElement('div');
          widgetDiv.className = 'cleverpush-widget';
          widgetDiv.dataset.id = widget._id;
          if (!widget.autoAppendPosition || widget.autoAppendPosition === 'top') {
            target.insertBefore(widgetDiv, target.firstChild);
          } else if (widget.autoAppendPosition === 'bottom') {
            target.appendChild(widgetDiv);
          }
        }
      }
    } catch (e) {
      log.warn('Failed appending widget', e);
    }
  });

  let hasExitIntent = false;
  const shownWidget = false;
  const widgets = document.querySelectorAll('.cleverpush-content-button, .cleverpush-widget');
  if (!widgets.length) {
    return;
  }

  import('./index').then(async ({ default: Widget }) => {
    Promise.all([...widgets].map(async (element, i) => {
      const isWidgetAlreadyExist = (context.config.widgets || []).some((widget) => widget._id === element.dataset.id);

      if (!isWidgetAlreadyExist) {
        const newWidget = await context.api.getWidget(element.dataset.id);
        context.config.widgets.push(newWidget);
      }

      if (element.dataset.widgetType === 'whatsapp-widget') {
        return;
      }

      const widget = new Widget(i, element, context.config, context.subscriptionManager, context.api, context.trigger.bind(context));
      const widgetConfig = widget.elementConfig;

      const bypassExitIntent = context.isMobile && widgetConfig.enableRegularDisplayForMobile && !widgetConfig.exitIntentForMobile;

      const isMessengerWidget = widget.isMessengerWidget('telegramChannel') || widget.isMessengerWidget('facebookChannel');
      if (context.webPushUnsupported && !isMessengerWidget && !widget.hasSharedWidgetChannels()) {
        // do not show widget when web push is not supported and this is not a messenger widget
        return;
      }

      if (widgetConfig.exitIntent && !bypassExitIntent) {
        if (hasExitIntent) {
          return;
        }

        if (context.isMobile && widgetConfig.exitIntentForMobile && !widgetConfig.enableRegularDisplayForMobile) {
          import('../utils/scriptFunctions').then(({ initMobileExitIntentListeners }) => {
            initMobileExitIntentListeners(WIDGET, shownWidget, element, widget, shownWidgets, storageKey, context);
          });
        }

        hasExitIntent = true;

        context.initElementExitIntentListener(WIDGET, shownWidget, element, widget, shownWidgets, storageKey);
      } else {
        import('../webBanner/initWebBanners').then(({ shouldShowBanner }) => {
          shouldShowBanner(false, widget, context).then((show) => {
            if (!show) {
              return;
            }

            setTimeout(() => {
              context.on(Event.SUBSCRIBED, () => {
                // use show instead of reset to re-paint topics
                widget.show(true);
              });
              context.on(Event.TOPICS_SET, () => {
                widget.show(true);
              });
              context.on(Event.TAGS_SET, () => {
                widget.show(true);
              });
              context.on(Event.UNSUBSCRIBED, () => {
                widget.show(false);
              });

              if (!context.subscriptionManager) {
                widget.show(false);
              }

              context.subscriptionManager?.isSubscribed().then((isSubscribed) => {
                widget.show(isSubscribed);

                // track confirm alert only when widget is visible
                if (widget.elementConfig.id && widget.element) {
                  if (isInViewport(widget.element)) {
                    widget.trackShown();
                  } else {
                    const enterViewportListener = () => {
                      if (isInViewport(widget.element)) {
                        window.removeEventListener('scroll', enterViewportListener);
                        widget.trackShown();
                      }
                    };
                    window.addEventListener('scroll', enterViewportListener, false);
                  }
                }
              });
              markElementAsShown(widget, storageKey);
              context.widgets.push(widget);
            }, (widget.timeout || 0) * 1000);
          });
        });
      }
    })).catch((err) => {
      log.error(err);
    });
  });
}
